class CloudStats extends HTMLElement {
  connectedCallback() {
    this.animated = false;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !this.animated) {
        this.animated = true;
        this.runAll();
        observer.disconnect();
      }
    }, { threshold: 0.15 });
    observer.observe(this);
  }

  runAll() {
    this.classList.add('cloud-stats--active');
    this.animateStats();
  }

  /* --- Stat counters (below illustrations) --- */
  animateStats() {
    const cards = this.querySelectorAll('.cloud-stat');
    cards.forEach((card, i) => {
      setTimeout(() => {
        card.classList.add('cloud-stat--animated');
        const numEl = card.querySelector('[data-count]');
        if (numEl) {
          const target = parseInt(numEl.dataset.count);
          if (!isNaN(target)) this.countUp(numEl, target, 2000);
        }
      }, 3000 + i * 200);
    });
  }

  countUp(el, target, duration) {
    const start = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(target * eased).toLocaleString();
      if (progress < 1) requestAnimationFrame(tick);
      else el.textContent = target.toLocaleString();
    };
    requestAnimationFrame(tick);
  }
}

customElements.define('cloud-stats', CloudStats);
